<template>
  <v-alert
    class="bg-accent"
    data-cy="headerAlert"
    rounded="shaped"
    elevation="1"
    position="fixed">
    <div class="d-flex align-center">
      <div class="mr-4">
        <slot></slot>
      </div>
      <v-btn
        data-cy="headerAlertBtn"
        variant="elevated"
        size="small"
        color="primary"
        rounded
        :loading="loading"
        @click="$emit('dismiss')">
        {{ buttonLabel }}
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: "HeaderAlert",
  props: {
    buttonLabel: { type: String, required: true },
    loading: { type: Boolean, default: false },
  },
  emits: ["dismiss"],
};
</script>

<style lang="scss" scoped>
.v-alert {
  top: 16px;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
